import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"
import { TAMANIO_IMG_COLUMNAS_LG, TAMANIO_IMG_COLUMNAS_SM, TAMANIO_IMG_COLUMNAS_XS } from "../../ayudas/constantes";
import { obtener_formulario_omitiendo_imagenes_ya_guardadas } from "../../ayudas/funciones"
import Lightbox from 'react-image-lightbox';
import Select from 'react-select';

//formulario para asignar un articulo a un colaborador
export default class asignarArticulo extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                articulo: null,
                fecha_asignado: null,
                departamento: null,
                colaborador: null,
                cantidad: null
            },
            colapsar: true,
            camposRequeridos: [],
            departamentoAreas: [],
            colaboradores: [],
            cantidadDb: null
        };
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
        this.datosRegistroValidos = this.datosRegistroValidos.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
    }

    componentDidMount() {
        this.obtenerDepartamentos();
        if (_valid(this.state.registro)) {
            this.setState({ cantidadDb: this.state.registro.cantidad });
        }
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    almacenarRegistro = async () => {

        if (this.datosRegistroValidos()) {
            const {
                registro,
                colaborador,
                departamento
            } = this.state

            let idArticulo = registro.id;
            let idColaborador = colaborador.value;
            let idDepartamento = departamento.value;
            let fecha = registro.fecha_asignado;
            let cantidad = registro.cantidad;
            let estado = registro.estado
            const data = {
                idArticulo,
                idColaborador,
                idDepartamento,
                fecha,
                cantidad,
                estado
            }
            this.guardarData(data);
        } else {
            
        }
    }

    guardarData = async (registro) => {
        this.apiRest.post('/asignarArticulo', registro).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Datos almacenados exitosamente!');
                this.saveHistory(resultado.data)
                this.props.history.replace({ pathname: '/listaAsignado', registro: resultado.data });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    saveHistory = (data) => {
        if (_valid(data)) {
            let registro = this.historial(data);
            this.apiRest.post('/asignarHistorial',registro).then(resultado => {
                if (resultado.exitoso) {
                    //console.log(resultado)
                }
            });
        }
    }

    historial = (data) => {
        let user = this.apiRest.getLS('du').colaborador.id
        if (_valid(data)) {
            let asignado = data.id
            let articulo = data.idArticulo
            let colaborador_que_asigna = user
            let colaborador_que_recibe = data.idColaborador
            let comentario = 'nuevo registro'
            let estado = 1
            const registro = {
                asignado,
                articulo,
                colaborador_que_asigna,
                colaborador_que_recibe,
                comentario,
                estado
            }
            return registro
        }
        return null
    }



    datosRegistroValidos() {
        const {
            registro,
            colaborador,
            departamento
        } = this.state;

        let contador = 0;
        const { camposRequeridos } = this.state;
        if (!_valid(registro.cantidad)) {
            camposRequeridos.push("cantidad");
        } else {
            let valor = this.state.cantidadDb
            if (registro.cantidad <= parseInt(valor)) {
                contador += 1;
            } else {
                camposRequeridos.push("La cantidad asignada excede de la capacidad almacenada, campo ");
            }
        }
        if (!_valid(departamento)) {
            camposRequeridos.push("departamento");
        } else {
            contador += 1;
        }
        if (!_valid(colaborador)) {
            camposRequeridos.push("colaborador");
        } else {
            contador += 1;
        }
        if (!_valid(registro.fecha_asignado)) {
            camposRequeridos.push("fecha asignado");
        } else {
            contador += 1;
        }
        this.setState({ camposRequeridos: camposRequeridos });
        setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);

        if (contador === 4) {
            return true
        } else {
            return false;
        }
    }

    //obtener area departamento
    obtenerDepartamentos() {
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: this.formatoSelect(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    //formato a valores de area
    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));

    //set nombre area
    setArea = asignado => {
        this.setState({ solicitar_area: asignado });
    }

    cambiosSolicitarA = asignado => {
        this.setState({ departamento: asignado });
        if (asignado != null) {
            this.getColaborador(asignado)
        } else {
            this.setState({ colaboradores: [] });
        }
    }

    cambiosSolicitar = asignado => {
        this.setState({ colaborador: asignado });
    }

    actualizarPagina = () => {
        window.location.reload(false);
    }

    getColaborador(data) {
        this.apiRest.get('/listaColaborador/' + data.value).then(resultado => {
            if (resultado.exitoso) {
                if (_valid(resultado.data)) {
                    this.setState({ colaboradores: this.formatoSelectColaborador(resultado) });
                } else {
                    toastr.error('No hay colaboradores asignados a ' + data.label);
                }
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    formatoSelectColaborador = valores => valores.data.map(i => ({ value: i.id, label: i.nombres + " " + i.apellidos }));

    render() {
        const {
            registro,
            colapsar,
            camposRequeridos,
            departamentosAreas,
            colaboradores
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Articulo" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Asignar Articulo</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={6}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo" className="form-label">
                                                                        Articulo: {this.state.registro.nombre}
                                                                    </Label>
                                                                    <p />
                                                                    <Label htmlFor="tipo" className="form-label">
                                                                        Marca: {this.state.registro.marca}
                                                                    </Label>
                                                                </div>
                                                            </Col>
                                                            <Col lg={6}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo" className="form-label">
                                                                        Serie: {this.state.registro.serie}
                                                                    </Label>
                                                                    <p />
                                                                    <Label htmlFor="tipo" className="form-label">
                                                                        Descripcion: {this.state.registro.descripcion}
                                                                    </Label>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo" className="form-label">
                                                                        Estado
                                                                    </Label>
                                                                    <select
                                                                        value={registro.estado}
                                                                        onChange={this.actualizarValores}
                                                                        name="estado"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">No Asignado</option>
                                                                        <option value="1">Proceso de Ensamble</option>
                                                                        <option value="2">Proceso de Configurado</option>
                                                                        <option value="3">Almacenado</option>
                                                                        <option value="4">Entregado</option>
                                                                        <option value="5">Rechazado</option>
                                                                        <option value="6">Aceptado</option>
                                                                        <option value="7">Parcialmente Aceptado</option>
                                                                        <option value="8">No aceptado</option>
                                                                        <option value="9">En Mantenimiento</option>
                                                                        <option value="10">De baja</option>
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col log={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="cantidad" className="form-label">
                                                                        Cantidad:
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.cantidad}
                                                                        onChange={this.actualizarValores}
                                                                        name="cantidad"
                                                                        min="0"
                                                                        max={registro.cantidad}
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa la cantidad"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="fecha_asignado" className="form-label">
                                                                        Fecha de Asignacion
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.fecha_asignado}
                                                                        onChange={this.actualizarValores}
                                                                        name="fecha_asignado"
                                                                        type="date"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={6}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="solicitar_a" className="form-label">
                                                                        ( Departamento / &Aacute;rea)
                                                                    </Label>
                                                                    <Select
                                                                        name="departamento"
                                                                        options={departamentosAreas}
                                                                        value={registro.departamento}
                                                                        onChange={this.cambiosSolicitarA}
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        placeholder="Selecciona.."
                                                                        isClearable={true}
                                                                        isSearchable={true}
                                                                        noOptionsMessage={() => "No hay más opciones"}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={6}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="colaborador" className="form-label">
                                                                        Colaborador
                                                                    </Label>
                                                                    <Select
                                                                        name="colaborador"
                                                                        options={colaboradores}
                                                                        value={registro.colaborador}
                                                                        onChange={this.cambiosSolicitar}
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        placeholder="Selecciona.."
                                                                        isClearable={true}
                                                                        isSearchable={true}
                                                                        noOptionsMessage={() => "No hay más opciones"}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/articuloAsignar') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="warning" onClick={() => this.actualizarPagina()}>
                                                        Cancelar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Guardar
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}